import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96c1bbce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "btn-search" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "13",
    fill: "currentColor",
    class: "bi bi-search",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" })
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Aeronaves", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Tarifas", -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "TIPOS DE AERONAVES")
], -1))
const _hoisted_14 = { class: "card overflow-scroll" }
const _hoisted_15 = { class: "table table-hover table-sm" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Aeronave"),
    /*#__PURE__*/_createElementVNode("th", null, "Descripcion"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "btn-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-upload",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" })
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-pencil-square",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
  })
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash3",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" })
], -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "TARIFAS")
], -1))
const _hoisted_28 = { class: "card overflow-scroll" }
const _hoisted_29 = { class: "table table-hover table-sm" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fecha Inicio"),
    /*#__PURE__*/_createElementVNode("th", null, "Fecha Final"),
    /*#__PURE__*/_createElementVNode("th", null, "Cargo"),
    /*#__PURE__*/_createElementVNode("th", null, "Descripcion"),
    /*#__PURE__*/_createElementVNode("th", null, "Costo Hora"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_31 = { class: "btn-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-upload",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" })
], -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-pencil-square",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
  })
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash3",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" })
], -1))
const _hoisted_37 = [
  _hoisted_36
]

import { ref, onMounted,computed } from 'vue';
import axios from 'axios';
import { Cartiaero, Cartarvue } from '@/interface/interfaces';
import { UrlGlobal } from '@/store/dominioGlobal';
import InCarTiaero from './pInsert/InCarTiaero.vue';
import UpCarTiaero from './pUpdate/UpCarTiaero.vue';
import InCarTarVue from './pInsert/InCarTarVue.vue';
import { useAlert } from '@/store/useAlert';

export default /*#__PURE__*/_defineComponent({
  __name: 'TarVue',
  setup(__props) {

const { error, success, question, warning } = useAlert()

const dUrl = UrlGlobal()
const search = ref('')
const options = ref('') 
const id_ref = ref<string | null>(null)
//-----------------------------------------------------------------
const cartiaero = ref<Array<Cartiaero>>([]);
const getAeronaves = () => {
    axios.get(dUrl.urlGlobal +'/api2/cartiaero/')
        .then(response => {
            cartiaero.value = response.data.map((item: Cartiaero) => {
                return {
                    ...item,
                    status: item.status === 'A' ? 'Activo' : 'Inactivo'
                };
            });
        })
        .catch(error => {
            console.error('Error al Cargar Aeronaves:', error);
        });
};
//----------------------------------------------------------------
const cartarvue = ref<Array<Cartarvue>>([])
const getTarifas = (id_aeronave: any, id_descripcion: any, id_status: any) => {
    id_ref.value = id_aeronave
    axios.get(`${dUrl.urlGlobal}/api2/cartiaero/cartarvue?id_aeronave=${id_aeronave}`)
        .then(response => {
            cartarvue.value = response.data;

            aeronave = id_aeronave
            descripcion = id_descripcion
            status = id_status

            if (clickUp.value == true || clickDl.value == true) {
                    FunClick(aeronave, descripcion, status)

                }

            if (clickTvUp.value == true || clickTvDl.value == true) {
                    FunClick(aeronave, descripcion, status)

                }
        })
        .catch(error => {
            console.error('Error al cargar los Cargos:', error);
        });
};

//----------------------------------------------------------------

// Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos segun la tabla------------------------------------------------
const filteredCarga1 = computed(() => {
    if (search.value === '') {
        // Si no hay nada en la búsqueda, retornar todos los registros
        return cartiaero.value;
    } else if (options.value == 'Aeronaves') {
        // Convertir el término de búsqueda a minúsculas para hacer la búsqueda insensible a mayúsculas
        const searchTerm = search.value.toLowerCase();
        // Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos
        return cartiaero.value.filter(elm => {
            return (
                elm.aeronave?.toLowerCase().includes(searchTerm) ||
                elm.descripcion?.toLowerCase().includes(searchTerm) ||
                elm.status?.toLowerCase().includes(searchTerm) 
            );
        });
    }else{
        return cartiaero.value
    }
});
//----------------------------------------------------------------
const filteredCarga2 = computed(() => {
    if (search.value === '') {
        return cartarvue.value;

    } else if (options.value == 'Tarifas') {
        const searchTerm = search.value.toLowerCase();

        return cartarvue.value.filter(elm => {
            return (
                elm.fecha_inicio?.toLowerCase().includes(searchTerm) ||
                elm.fecha_final?.toLowerCase().includes(searchTerm) ||
                elm.cargo?.toLowerCase().includes(searchTerm) ||
                elm.nombre_cargo?.toLowerCase().includes(searchTerm) ||
                elm.costo_hora?.toLowerCase().includes(searchTerm) ||
                elm.nom_status?.toLowerCase().includes(searchTerm) 
            );
        });
    }else{
        return cartarvue.value
    }
});

//funcion de los botones y las extenciones de Insert,delete,update----------------
let aeronave: any
let descripcion: any
let status: any
let btnUp = ref(false);//variable para mostrar modal de update
let clickUp = ref(false)//variable para activar el click de Up
let btnIn = ref(false);//variable modal insert
let btnDl = ref(false);//variable para mostrar modal del delete
let clickDl = ref(false);//variable para activar el click del delete

let btnTvUp = ref(false);//variable para mostrar modal de update
let clickTvUp = ref(false)//variable para activar el click de Up
let btnTvIn = ref(false);//variable modal insert
let btnTvDl = ref(false);//variable para mostrar modal del delete
let clickTvDl = ref(false);//variable para activar el click del delete

//funciones q activan el click y en el caso del insert muestran el modal
const CbtnUp = () => {
  clickUp.value = !clickUp.value
  clickDl.value = false
}
const CbtnIn = () => {
  btnIn.value = !btnIn.value
  clickUp.value = false
  clickDl.value = false
}

const CbtnDl = () => {
  clickDl.value = !clickDl.value
  clickUp.value = false
}

const CbtnTvUp = () => {
  clickTvUp.value = !clickTvUp.value
  clickTvDl.value = false
}
const CbtnTvIn = () => {
  btnTvIn.value = !btnTvIn.value
  clickTvUp.value = false
  clickTvDl.value = false
}

const CbtnTvDl = () => {
  clickTvDl.value = !clickTvDl.value
  clickTvUp.value = false
}
//funcion principal para el funcionamiento de el update y delete cuando uno de los 2 este activado
const FunClick = (n: any, nm: any, st: any) => {
  aeronave = n;
  descripcion = nm;
  status = st;

  if (clickUp.value == true) {
    btnUp.value = !btnUp.value
    clickUp.value = !clickUp.value
  }
  if (clickDl.value == true) {
    btnDl.value = !btnDl.value
    clickDl.value = !clickDl.value
  }

   if (clickTvUp.value == true) {
    btnTvUp.value = !btnTvUp.value
    clickTvUp.value = !clickTvUp.value
  }
}

//funciones de emits para actualizar las variables y cierre los modales activos sea de update o insert
function updatePropsValue(newValue: boolean) {
  btnUp.value = newValue
  getAeronaves()
}
function insertPropsValue(newValue: boolean) {
  btnIn.value = newValue
  getAeronaves();
}

function deletePropsValue(newValue: boolean) {
  btnDl.value = newValue
  getAeronaves()
}

function updateTvPropsValue(newValue: boolean, aeronave: any) {
  btnTvUp.value = newValue
  aeronave.value = String 
  getTarifas(aeronave, null, null)
}
function insTvPropsValue(newValue: boolean, aeronave: any) {
  btnTvIn.value = newValue
  aeronave.value = String
  getTarifas(aeronave, null, null);
}

function deleteTvPropsValue(newValue: boolean, aeronave: any) {
  btnDl.value = newValue
  aeronave.value = String
  getTarifas(aeronave, null, null)
}
//-------------------------------------------------------------------------------
//----------------------------------------------------------------

onMounted(() => {
    getAeronaves();
    getTarifas('1', null, null)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "search",
              id: "search",
              placeholder: "Buscar",
              style: {"background-color":"transparent","border":"none","outline":"none","color":"white"},
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event))
            }, null, 512), [
              [_vModelText, search.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              style: {"background-color":"transparent","border":"none","outline":"none","color":"black"},
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((options).value = $event))
            }, _hoisted_9, 512), [
              [_vModelSelect, options.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga1.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.aeronave,
                        onClick: ($event: any) => (getTarifas(elm.aeronave, elm.descripcion, elm.status)),
                        class: _normalizeClass({ 'table-primary': elm.aeronave === id_ref.value })
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.aeronave), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.descripcion), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.status), 1)
                      ], 10, _hoisted_17))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  class: "btn-insert",
                  onClick: _withModifiers(CbtnIn, ["prevent"])
                }, _hoisted_20),
                _createElementVNode("button", {
                  class: "btn-update",
                  onClick: _withModifiers(CbtnUp, ["prevent"])
                }, _hoisted_22),
                _createElementVNode("button", {
                  class: "btn-delete",
                  onClick: _withModifiers(CbtnDl, ["prevent"])
                }, _hoisted_24)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("table", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga2.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.aeronave
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.fecha_inicio), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.fecha_final), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.cargo), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nombre_cargo), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.costo_hora), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_status), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  class: "btn-insert",
                  onClick: _withModifiers(CbtnTvIn, ["prevent"])
                }, _hoisted_33),
                _createElementVNode("button", {
                  class: "btn-update",
                  onClick: _withModifiers(CbtnTvUp, ["prevent"])
                }, _hoisted_35),
                _createElementVNode("button", {
                  class: "btn-delete",
                  onClick: _withModifiers(CbtnTvDl, ["prevent"])
                }, _hoisted_37)
              ])
            ])
          ])
        ]),
        (_unref(btnUp))
          ? (_openBlock(), _createBlock(UpCarTiaero, {
              key: 0,
              aeronave: _unref(aeronave),
              descripcion: _unref(descripcion),
              status: _unref(status),
              btnUp: _unref(btnUp),
              onUpdateProps: updatePropsValue
            }, null, 8, ["aeronave", "descripcion", "status", "btnUp"]))
          : _createCommentVNode("", true),
        (_unref(btnIn))
          ? (_openBlock(), _createBlock(InCarTiaero, {
              key: 1,
              btnIn: _unref(btnIn),
              onInsertProps: insertPropsValue
            }, null, 8, ["btnIn"]))
          : _createCommentVNode("", true),
        (_unref(btnTvIn))
          ? (_openBlock(), _createBlock(InCarTarVue, {
              key: 2,
              aeronave: _unref(aeronave),
              btnTvIn: _unref(btnTvIn),
              onInsTvProps: insTvPropsValue
            }, null, 8, ["aeronave", "btnTvIn"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})